import { alpha, createTheme } from "@mui/material/styles";
import typography from "./Typography";
import { shadows } from "./Shadows";

const primaryMain = '#3f6c9a';
const secondaryMain = '#da7340';

const baselightTheme = createTheme({
  direction: 'ltr',
  palette: {
    primary: {
      main: primaryMain,
      light: '#ECF2FF',
      dark: '#4570EA',
    },
    secondary: {
      main: secondaryMain,
      light: '#E8F7FF',
      dark: '#23afdb',
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#1682d4',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FA896B',
      light: '#FDEDE8',
      dark: '#f3704d',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547',

    },
    text: {
      primary: '#2A3547',
      secondary: '#5A6A85',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc',
    },
    divider: '#e5eaef',
  },
  typography,
  shadows,
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: '0.01em',
          padding: '10px 16px',
          minHeight: 44,
          boxShadow: 'none',
          transition: 'all 140ms ease',
        },
        containedPrimary: {
          color: '#fff',
          backgroundImage: `linear-gradient(135deg, ${primaryMain}, #264b74)`,
          boxShadow: '0 10px 30px rgba(63,108,154,0.2)',
          '&:hover': {
            backgroundImage: `linear-gradient(135deg, #345b85, #1f3f61)`,
            boxShadow: '0 12px 32px rgba(63,108,154,0.26)',
          },
          '&:active': {
            transform: 'translateY(1px)',
            boxShadow: '0 8px 24px rgba(63,108,154,0.22)',
          },
        },
        outlinedPrimary: {
          color: primaryMain,
          borderColor: alpha(primaryMain, 0.32),
          backgroundColor: alpha(primaryMain, 0.04),
          '&:hover': {
            borderColor: primaryMain,
            backgroundColor: alpha(primaryMain, 0.1),
          },
          '&:active': {
            backgroundColor: alpha(primaryMain, 0.14),
          },
        },
        textPrimary: {
          color: primaryMain,
          '&:hover': {
            color: '#264b74',
            backgroundColor: alpha(primaryMain, 0.08),
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#f9fbff',
          transition: 'border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d6deea',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b9c5d6',
          },
          '&.Mui-focused': {
            backgroundColor: '#fff',
            boxShadow: `0 0 0 4px ${alpha(primaryMain, 0.12)}`,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1.5px',
            borderColor: primaryMain,
          },
          '& .MuiInputBase-input': {
            padding: '14px 16px',
          },
          '&.Mui-disabled': {
            backgroundColor: '#f4f6f8',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e0e6ed',
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: '#546074',
          '&.Mui-focused': {
            color: primaryMain,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          color: '#6b7280',
          fontWeight: 500,
        },
      },
    },
  },
},
  
);

export { baselightTheme };
